window.CloudNineGiftDetails = (root, copy) => {
  const giftDialog = document.createElement("dialog");
  giftDialog.className = "gift-dialog";
  giftDialog.setAttribute("aria-labelledby", "gift-title");
  giftDialog.innerHTML = '<button type="button" class="gift-close" aria-label="Close gift details"><svg class="system-icon" width="20" height="20" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"/></svg></button><img alt=""><h2 id="gift-title"></h2><p class="gift-one-line"></p><div class="gift-value-row"><del class="gift-value"></del><strong>FREE \xB7 $0</strong></div><p class="gift-saving"></p><p class="gift-description"></p><p class="gift-disclaimer" hidden></p>';
  root.append(giftDialog);
  root.addEventListener("click", (e) => {
    const trigger = e.target.closest(".gift-preview-trigger");
    if (!trigger) return;
    const name = trigger.dataset.giftName;
    const detail = copy.giftDetails[trigger.dataset.giftKey];
    if (!detail) return;
    giftDialog.querySelector("img").src = trigger.dataset.giftImage;
    giftDialog.querySelector("img").alt = name;
    giftDialog.querySelector("h2").textContent = name;
    giftDialog.querySelector(".gift-one-line").textContent = detail.line;
    giftDialog.querySelector(".gift-value").textContent = trigger.dataset.giftValue;
    giftDialog.querySelector(".gift-saving").textContent = copy.giftIncluded;
    giftDialog.querySelector(".gift-description").textContent = detail.description;
    const disclaimer = giftDialog.querySelector('.gift-disclaimer');
    disclaimer.textContent = detail.disclaimer || '';
    disclaimer.hidden = !detail.disclaimer;
    giftDialog.showModal();
  });
  giftDialog.querySelector(".gift-close").addEventListener("click", () => giftDialog.close());
  giftDialog.addEventListener("click", (e) => {
    if (e.target === giftDialog) giftDialog.close();
  });
};
